export const SET_DWI_CATEGORIES = 'SET_DWI_CATEGORIES';
export const UPDATE_DWI_CATEGORIES = 'UPDATE_DWI_CATEGORIES';